export class CarrierLane {
    id: number;
    laneCode: string;
}